import { Stack } from "@mui/material";

import Nav from "./Nav/Index";
import Main from "./Main/Index";
import useResponsive from "@/hooks/useResponsive";
import { createContext, useState } from "react";
import { useAuthContext } from "@/auth/useAuthContext";
// import { infoApi } from "@/http";
// import { merchantStroe } from "@/stores";
// import { useAuthContext } from "@/auth/useAuthContext";
// import { getCookieByName } from "@/utils/until";

export const MyLayoutContext = createContext<{
  navOpen: boolean;
  setNavOpen: (v: boolean) => void;
}>({
  navOpen: false,
  setNavOpen: () => {},
});

export default function Index() {
  const isMobile = !useResponsive("up", "lg");
  const [navOpen, setNavOpen] = useState(false);

  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  // console.log("user-doclayout", user);

  // const { setUserInfo } = merchantStroe;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // const getUser = async () => {
  //   setUserInfo({
  //     role_id: 20,
  //     name: "xxx",
  //   });
  //   console.log("UserInfo-----doclayout");
  //   // setCheck(false);
  //   try {
  //     const res = await infoApi.getUserToken();
  //     // // const { token } = await res.json();
  //     // console.log("token--res", res);
  //     if (res && res?.token) {
  //       localStorage.setItem("Authorization", JSON.stringify(res.token));
  //     }

  //     if (!res?.token) return;

  //     const userInfo = await infoApi.getUserInfo();
  //     // console.log("userInfo-doclayout", userInfo);
  //     if (userInfo?.detail) {
  //       if ([1, 2, 8].includes(userInfo?.detail?.role_id)) {
  //         setUserInfo(userInfo.detail);
  //         setCheck(true);
  //       } else {
  //         // setCheck(false);
  //         // setUserInfo({ role_id: 0 });
  //       }
  //     }
  //   } catch (error: any) {
  //     console.error(error);
  //     console.log("2222222", error);
  //     if ([1012].includes(error?.code)) {
  //       // setCheck(false);
  //     }
  //     // setCheck(false);
  //   }
  // };

  // useEffect(() => {
  //   getUser();
  // }, [getUser]);

  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      flexWrap={isMobile ? "wrap" : "nowrap"}
      component={"main"}
      sx={{ width: 1, minHeight: { lg: 1 } }}
    >
      <MyLayoutContext.Provider
        value={{
          navOpen,
          setNavOpen: (v) => {
            setNavOpen(v);
          },
        }}
      >
        <Nav isCheck={check} />
        <Main isCheck={check} />
      </MyLayoutContext.Provider>
    </Stack>
  );
}
